import { defineStore } from 'pinia'
import { reactive, watch } from 'vue'
import { datadogService } from '@/services/datadog'

export const useUserStore = defineStore('user', () => {
  interface Profile {
    id: number | undefined,
    displayName: string,
    thumbImageUrl: string,
    mailaddress: string,
    hasProfileForComment: boolean,
    isSignedIn: boolean,
  }
  const context: Profile = reactive({
    id: undefined,
    displayName: '',
    thumbImageUrl: '',
    mailaddress: '',
    hasProfileForComment: false,
    isSignedIn: false,
  })

  /**
   * プロフィール情報の設定
   * @param thumbImageUrl 画像の URL
   * @param mailaddress ユーザのメールアドレス
   * @param isSignedIn サインインしているかどうか
   */
  const setProfile = (
    {
      thumbImageUrl,
      mailaddress,
      isSignedIn,
    }: Profile
  ) => {
    context.thumbImageUrl = thumbImageUrl
    context.mailaddress = mailaddress
    context.isSignedIn = isSignedIn
  }

  // contextの変更を監視してDatadogのユーザーコンテキストを自動更新
  // immediate にしない: 初期値（未ログイン扱い）で clearUser() が走ると、datadog.ts が初期化直後に
  // layout の data-user-id から付けた user_id を mount 中に消してしまう。値は assignStoreData() で必ず変わるので watch だけで足りる
  watch(
    () => [context.id, context.isSignedIn],
    ([newId, newIsSignedIn]) => {
      if (newIsSignedIn && newId) {
        console.debug('Datadog: Setting user context with ID:', newId)
        datadogService.setUser({
          id: String(newId),
        })
      } else {
        console.debug('Datadog: Clearing user context')
        datadogService.clearUser()
      }
    }
  )

  return {
    // data
    context,

    // methods
    setProfile,
  }
})
